import { render } from "./AccountButton.vue?vue&type=template&id=fe552b4a&scoped=true"
import script from "./AccountButton.vue?vue&type=script&lang=js"
export * from "./AccountButton.vue?vue&type=script&lang=js"

import "./AccountButton.vue?vue&type=style&index=0&id=fe552b4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe552b4a"]])

export default __exports__